export const STATUS_APPROVED = "APPROVED";
export const STATUS_NEW = "NEW";
export const STATUS_ACTIVATED = "ACTIVATED";
export const STATUS_INVITED = "INVITED";
export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_CALL_SCHEDULED = "CALL_SCHEDULED";
export const STATUS_CALL_REQUESTED = "CALL_REQUESTED";
export const STATUS_INFORMATION_REQUESTED = "INFORMATION_REQUESTED";
export const STATUS_INFORMATION_SUBMITTED = "INFORMATION_SUBMITTED";
export const STATUS_DUE_DILIGENCE_COMPLETED = "DUE_DILIGENCE_COMPLETED";

export const STATUS_PENDING = "PENDING";
export const STATUS_COMPLETED = "COMPLETED";
export const STATUS_REQUESTED = "REQUESTED";
export const STATUS_CANCELLED = "CANCELLED";
export const STATUS_UPLOADED= "UPLOADED";
export const STATUS_UPLOADED_BY_CONSULTANT= "UPLOADED_BY_CONSULTANT"

export const BRAND_ASSETS = "BRAND_ASSETS";
export const PRODUCT_ASSETS = "PRODUCT_ASSETS";

export const DATE_FORMAT_DD_MM_YYYY = "DD/MM/YYYY"

export const DATE_FORMAT_DD_MMM_YYYY = "DD MMM YYYY"

export const DATE_FORMAT_DD_MM_YYYY_HH_mm_A = "DD/MM/YYYY | hh:mm A"

export const DATE_FORMAT_HH_mm_A = "hh:mm A"

export const BRANDS = "BRAND";
export const PARTNERS = "PARTNER";
export const TODO_STATUS_PENDING= "Pending";
export const TODO_STATUS_COMPLETED= "Completed";

export const USER_TYPE_ORGANIZATION = "organization"
export const USER_TYPE_ADMIN = "admin"
export const USER_TYPE_PARTNER = "partner"
export const USER_TYPE_ADMINISTRATIVE = "administrative"

export const TAB_INFO = "INFO";
export const TAB_MARKETS = "MARKETS";
export const TAB_PRODUCTS = "PRODUCTS";
export const TAB_ASSETS = "ASSETS";
export const TAB_SERVICE_SCOPE = "SERVICE_SCOPE";

export const TAB_PROFILE = "PROFILE";
export const TAB_DOCS = "DOCS";
export const TAB_MESSAGES = "MESSAGES";

export const OPTION_OTHER = "Other"

export const CAT_FOCUS_CATEGORY = "FOCUS_CATEGORY";
export const CAT_CAPABILITIES = "CAPABILITIES";
export const CAT_ENGAGEMENT_TERMS = "ENGAGEMENT_TERMS";

export const STATUS_INTERESTS_RECEIVED= "INTERESTS_RECEIVED";
export const STATUS_INTERESTS_EXPRESSED= "INTERESTS_EXPRESSED";
export const STATUS_RECOMMENDED= "recommended";


export const TYPE_MESSAGES= "MESSAGES";
export const TYPE_NOTIFICATIONS= "NOTIFICATIONS";


export const PARTNER_SUITABLE= "SUITABLE_PARTNERS";
export const PARTNER_INTERESTED= "INTERESTED_PARTNERS";

export const STATUS_OPEN ="Open";
export const STATUS_INTEREST_ACCEPTED ="Interest Accepted";
export const STATUS_INTEREST_EXPRESSED ="Interest Expressed";
export const STATUS_INTEREST_RECEIVED ="Interest Received";

export const STATUS_PARTNER_INTEREST_EXPRESSED ="interest expressed";
export const STATUS_PARTNER_INTEREST_ACCEPTED ="interest accepted";
export const STATUS_PARTNER_INTEREST_SKIPPED ="skipped";

export const DOC_STATUS_REQUESTED = "requested";
export const DOC_STATUS_UPLOADED = "uploaded";
export const DOC_STATUS_CANCELLED = "cancelled";
export const DOC_STATUS_PENDING_UPLOAD = "pending upload";

